export const validatePendantChainFields = (filters) => {
  const fieldNames = [
    'pendant_chain_length',
    'pendant_chain_metal_type',
    'pendant_chain_width'
  ]

  const fieldErrorMsgMapping = {
    'pendant_chain_length': 'chain_length',
    'pendant_chain_metal_type': 'chain_primary_metal',
    'pendant_chain_width': 'chain_weight'
  }

  let missingFields = fieldNames.filter((e) => { return filters[e] === null })

  return missingFields.map((field) => {
    return fieldErrorMsgMapping[field]
  })
}



// WEBPACK FOOTER //
// ./src/containers/jewelry/validations/pendant-chain-fields/index.js